var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (this.article)?_c('div',[_vm._t("default",[_c('span',{domProps:{"innerHTML":_vm._s(_vm.article.content)}})],{"article":_vm.article})],2):_c('div')}
var staticRenderFns = []

export { render, staticRenderFns }